export default __webpack_public_path__ + "static/media/template-preview.0e1baaec.png";